export const NETWORK = 'xdai'
// Final farm - 30 day
export const POOL_ADDRESS = '0xd9E090763BAa5c1Fe28104bf4974DBc3652479AC'

// Test farm 30 day
// export const POOL_ADDRESS = '0x7B60bF83F184DCF197a72D16BAB207999677875A'
// Test farm 1 hour
// export const POOL_ADDRESS = '0xdC88CeA35211bbe56cA692e051E40719Dedf09F6'
export const STAKING_TOKEN_ADDRESS =
  '0x97Edc0e345FbBBd8460847Fcfa3bc2a13bF8641F'
export const REWARD_TOKEN_ADDRESS = '0x97Edc0e345FbBBd8460847Fcfa3bc2a13bF8641F'
export const BACKGROUND_COLOR = '#F1EEFC'
export const FOREGROUND_COLOR = '#1d0815'

export const merchantList = [
  {
    url:
      'https://app.honeyswap.org/#/swap?inputCurrency=0xe91d153e0b41518a2ce8dd3d7944fa863463a97d&outputCurrency=0x97edc0e345fbbbd8460847fcfa3bc2a13bf8641f&chainId=100',
    name: 'Honeyswap',
    id: 'honeyswap',
    iconName: 'honeyswap',
    iconColor: '#000000',
    bgColor: '#FFF4AD',
  },
]
